import $ from 'jquery';
import { visualizerDidUpdateEvent } from './lib/constants'
import { storeSvg } from './lib/store-svg'
import { defaultProperties } from './lib/constants'
import { mmToPx } from './lib/utils/mm-to-px'
import { paintTile } from './lib/paint-tile'
import { paintMeasureIndicators } from './lib/paint-measure-indicators'
import { getDefaultStyles } from './lib/get-default-styles'
import Raphael from 'raphael'

// Global variables
window.visualizer = {};
window.visualizer.paper = {};
window.visualizer.styles = {};
window.visualizer.tiles = [{}];
window.visualizer.measureIndicators = {};
window.visualizer.currentSingleTileWidth = 0;
window.visualizer.currentTileHeight = 0;
window.visualizer.currentTotalTileWidth = 0;
window.visualizer.currentColor = defaultProperties.color;
window.visualizer.currentWindowbackGlazingHeight = null;
window.visualizer.glazingWidth = 0;
window.visualizer.glazingHeight = 0;

function initVisualizer() {
    if (!tileSettings) {
        console.log("tileSettings is not set");
        return;
    }

    if (tileSettings.hasOwnProperty('showHandle')) {
        tileSettings.showHandle = tileSettings.showHandle === "false" ? false : tileSettings.showHandle;
    }

    if (tileSettings.hasOwnProperty('sliding')) {
        tileSettings.sliding = tileSettings.sliding === "" ? false : tileSettings.sliding;
    }


    if (tileSettings.hasOwnProperty("properties")) {
        $.extend(defaultProperties, tileSettings.properties);
    }

    visualizer.styles = getDefaultStyles();

    var canvasWidth = mmToPx(tileSettings.maxWidth) + (visualizer.styles.lengthIndicator.offset + visualizer.styles.lengthIndicator.fontSize);
    var canvasHeight = mmToPx(tileSettings.maxHeight) + (visualizer.styles.lengthIndicator.offset + visualizer.styles.lengthIndicator.fontSize);
    visualizer.paper = Raphael("visualizer", canvasWidth, canvasHeight);

    paintTile(visualizer.paper, visualizer.tiles[0], visualizer.styles);
    paintMeasureIndicators(visualizer.paper, visualizer.measureIndicators, visualizer.styles);

    // Listen for visualizer update to store svg in localStorage
    window.addEventListener(visualizerDidUpdateEvent.type, storeSvg)
}

export { initVisualizer }